import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { CoreModule } from '@alfresco/adf-core';

import { WKDcoratorsComponent } from './components';
import { CKEditorModule } from '../../components/ckeditor';
import { DecoratorStoreModule } from './state/decorators.store.module';
import { EditorSharedModule } from '../../components/shared/components/editor-shared';
import { WkTabsHoverAnimationDirective } from '../../components/info-drawer/directives/wk-tabs-hover-animation/wk-tabs-hover-animation.directive';
import { WkTcCrossLinksPanelComponent } from '../../components/wk-tc-cross-links-panel/wk-tc-cross-links-panel.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    MatTabsModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    CKEditorModule,
    DecoratorStoreModule,
    EditorSharedModule,
    WkTabsHoverAnimationDirective,
    FormsModule,
  ],
  declarations: [WKDcoratorsComponent, WkTcCrossLinksPanelComponent],
  exports: [WKDcoratorsComponent],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WKDocumentDecoratorModule {}
